<template>
  <div>

    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">Location Master</h3>
      
      <div class="action_bar mb-3">
        <b-button
            class="btn-action-lg"
            size="sm"
            variant="info"
            :to="{ name: 'wms_locations_add' }"
          >Add Location
        </b-button>
      </div>  
      <!-- <div class="search_bar mb-3">
        <b-row v-if="this.$store.state.user_obj.account_type == 'admin'">
          <b-col cols="4" class="pr-1">
            <b-form-file
              v-model="upload_file"
              placeholder="Choose a file..."
            ></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onUploadFile"
              >Upload</b-button
            >
          </b-col>
        </b-row>
      </div> -->

      <!-- <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.status_selected"
              :options="status_options"
            />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Order# / Shopify ID / Tracking #"
              v-model="search_criteria.keyword"
             @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>
            
            <b-button class="btn-action" size="sm" variant="info" @click="exportCSV">Export CSV</b-button>
          </b-col>
        </b-row>
      </div> -->

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
        :fields="fields"
      >
        <!-- <b-table responsive small outlined striped hover :items="items"> -->
        <template slot="status" slot-scope="data">{{
          data.item.status
        }}</template>

        <template slot="changes" slot-scope="data">
          <div
            style="max-width: 200px; white-space: pre-line; word-break: break-word;"
          >
            {{ data.item.from_val }} ->{{ data.item.to_val }}
            <div v-if="data.item.other_reason">
              [{{ data.item.other_reason }}]
            </div>
            <div
              v-if="
                data.item.reschedule_date &&
                  data.item.reschedule_date != '0000-00-00 00:00:00'
              "
            >
              [{{ data.item.reschedule_date }}]
            </div>
          </div>
        </template>

        <template slot="updated_at" slot-scope="data">
          <div v-if="data.item.updated_by != ''">
            {{ data.item.updated_at }}
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button
            class="btn-default"
            size="sm"
            variant="primary"
            :to="{
              name: 'wms_locations_edit',
              params: { wms_location_id: data.item.id }
            }"
            >Edit</b-button
          >

          <b-button
            class="btn-danger"
            size="sm"
            variant="primary"
            @click.stop="showModal_confirmDelete(data.item)"
            >Delete</b-button
          >
        </template>

        <!-- <template slot="action" slot-scope="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            :to="{
              name: 'tracking_detail',
              params: { id: data.item.tracking_id }
            }"
            :disabled="!data.item.tracking_id"
            >Detail</b-button
          >

          <b-button
            v-if="
              ($store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs') &&
                data.item.status == 'pending'
            "
            class="btn-action"
            size="sm"
            variant="success"
            @click.stop="executeCR(data.item)"
            >Execute</b-button
          >

          <b-button
            v-if="data.item.status == 'pending'"
            class="btn-action"
            size="sm"
            variant="danger"
            @click.stop="cancelCR(data.item)"
            >Cancel</b-button
          >
        </template> -->
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-modal ref="modal_confirmDelete" centered hide-footer hide-header>
        <div class="d-block">
            <b-row class="mb-3">
                <b-col>Are you sure to delete this location?</b-col>
            </b-row>
        </div>
        <div class="text-right">
            <b-btn
                class="mt-3"
                variant="outline-danger"
                @click="hideModal_confirmDelete"
                >Cancel</b-btn
            >
            <b-btn
                class="mt-3"
                variant="outline-success"
                @click="deleteLocation()"
                >Confirm</b-btn
            >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "location_code",
    label: "Location Code"
  },
  {
    key: "location_priority",
    label: "Location Priority"
  },
  {
    key: "remark",
    label: "Remark"
  },
  {
    key: "created_at",
    label: "Created at"
  },
  {
    key: "created_by_name",
    label: "Created by"
  },
  {
    key: "action",
    label: "Action"
  },
];

export default {
  name: "WMS_Locations",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: false,
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Fulfilled",
          text: "Fulfilled"
        },
        {
          value: "Failed",
          text: "Failed"
        }
        ],
    };
  },
  async created() {
    await this.getWMS_Locations();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST;
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getWMS_Locations() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_location_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id,
        }
      });
      this.items = response.data.locations;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getWMS_Locations();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getWMS_Locations();
    },

    showModal_confirmDelete(item) {
            this.$refs.modal_confirmDelete.item = item;
            this.$refs.modal_confirmDelete.show();
        },

    hideModal_confirmDelete() {
        this.$refs.modal_confirmDelete.hide();
    },

    async deleteLocation() {
      let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "wms_location_delete.php",
          data: {
              location_id: this.$refs.modal_confirmDelete.item.id,
              client_id: this.$store.state.user_obj.client_id,
              user_id: this.$store.state.user_obj.user_id
          }
      });
      this.getWMS_Locations();
      this.hideModal_confirmDelete();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_inventory_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        window.location.reload();
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/WMS_Locations.vue